import type { DocumentStaticContent } from '@core-api/editor/types/response';
import type { Question } from '@mentimeter/legacy-series-types/question';

export const getDocumentStaticContent = (question: Question) => {
  const content: DocumentStaticContent = {
    type: 'document',
    label: question.title_meta,
    heading: question.question,
  };

  return content;
};
